// extracted by mini-css-extract-plugin
export var aggregationCell = "_1o-f";
export var aggregationRow = "_1o-e";
export var borderlessSpinnerContainer = "_1o-2";
export var closeIcon = "_1o-7";
export var expandIcon = "_1o-8";
export var expanded = "_1o-9";
export var filterDropdown = "_1o-a";
export var filterDropdownDivider = "_1o-5";
export var filterDropdownHeader = "_1o-d";
export var filterDropdownItem = "_1o-c";
export var filterDropdownModal = "_1o-b _1o-a";
export var filterItem = "_1o-4";
export var normalCellWithAdjustableBorder = "_1o-6";
export var pinButtonContainer = "_1o-g";
export var pinIcon = "_1o-h";
export var pinIconActive = "_1o-i";
export var spinner = "_1o-0";
export var spinnerContainer = "_1o-1";
export var tableContainer = "_1o-3";
export var viewButtonContainer = "_1o-j";